<!--/*
 * Copyright (c) 2020 The Awareness Company. All rights reserved. 
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */ -->
<template>
  <v-row>
    <v-col cols="2" lg="3" md="4" sm="2" class="pa-0 ma-0 pl-3">
      <img
          src="../../../public/assets/un-emblem.svg"
          v-bind:style="{ 'height': $vuetify.breakpoint.lgAndUp? '55px': '35px', 'vertical-align': 'middle'}"
          class="ml-5"
        />
    </v-col>
    <v-col cols="10" lg="6" md="4" sm="6" class="pa-0 ma-0">
      <div
        class="title pl-3"
        v-bind:style="{ 'font-size': $vuetify.breakpoint.lgAndUp? '28px !important': '18px !important', 'font-weight': '400', 'text-align': 'center' }"
      >
        <span class="pr-3">COVID-19</span>
        <img
          src="../../../public/assets/awareness.png"
          v-bind:style="{ 'height': $vuetify.breakpoint.lgAndUp? '55px': '35px', 'vertical-align': 'middle'}"
          class="pr-3"
        />
        <span class="pr-3">-</span>
        <span v-if="!countryDisplay || countryDisplay === ''">AFRICA</span>
        <span
          v-if="$vuetify.breakpoint.lgAndUp"
          style="text-transform: uppercase;"
          class="ml-3"
        >{{countryDisplay}}</span>
        <div v-else style="text-transform: uppercase;" class="ml-3">{{countryDisplay}}</div>
      </div>
    </v-col>
    <v-col cols="12" lg="3" md="4" sm="4" style="text-align: right;" class="pa-0 ma-0">
      <Menu class="mr-5 pr-5"></Menu>
    </v-col>
  </v-row>
</template>

<script>
import Menu from "@/components/africa/Menu";

export default {
  name: "Header",
  props: ["countryDisplay"],
  data: () => ({}),
  components: {
    Menu
  },
  methods: {},
};
</script>
